import { setPasswordApi, SetPasswordPayloadType } from '@/api/v1/users/setPasswordApi';
import { prepareResponse, throwResponseError } from '@/helpers/apiHelpers/responseHelpers';

export const setPassword = async (payload: SetPasswordPayloadType) => {
  try {
    const response = await setPasswordApi(payload);

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};
